<template>
    <button
        class="form-submit"
        :class="{loading: loading}"
        :type="type"
        :disabled="loading"

    >
        <span>{{ label }}</span>

        <Loader v-if="loading" :is-active="loading" />

    </button>
</template>

<script>
    import Loader from '@/components/loader/Loader'
    export default {
        name: "FormSubmit",
        components: {Loader},
        props: {
            label: {
                type: String,
                required: true
            },
            loading: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: 'submit'
            }
        }
    }
</script>

<style lang="scss">
    @import 'src/assets/scss/_variables/color';
    @import 'src/assets/scss/_variables/fonts';
    @import 'src/assets/scss/_variables/mixin';

    .form-submit {
        background: $color-primary;
        border: 0;
        border-radius: 4px;
        color: #fff;
        display: inline-block;
        font-size: 1.7rem;
        font-family: $font-family;
        font-weight: $font-weight-normal;
        outline: none;
        text-align:center;
        padding: 1em 2.5em;
        cursor: pointer;
        transition: .2s;
        position: relative;

        span {
            display: inline-block;
            position: relative;
            &:after {
                position: relative;
                display: inline-block;
                content: '';
                border-top: white solid 2px;
                border-right: white solid 2px;
                transform: rotate(45deg);
                margin: 0 -10px 0 10px;
                @include size(9px);
            }
        }

        &:hover:not(:disabled) {
            background: $color-primary-lighter;
        }

        &.loading {
            cursor: wait;
            span {
                opacity: 0;
            }
        }

        .loader {
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            path {
                // stroke-dasharray: 25,25;
                stroke-width: 4px;
            }
        }


    }
</style>
